import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Chip, CircularProgress, IconButton, LinearProgress, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import { DownloadJob } from 'common-models/src/Downloads';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export interface DownloadJobRowProps {
    job: DownloadJob;
    onDelete: (jobId: string) => void;
    isDeleting: boolean;
    getStatusText: (state: string) => string;
    getStatusColor: (state: string) => string;
    formatDate: (dateString?: string) => string;
    formatTtlDate: (ttlSeconds?: number) => string;
    getProgressPercentage: (job: DownloadJob) => number;
}


const DownloadJobRow: React.FC<DownloadJobRowProps> = ({
    job,
    onDelete,
    isDeleting,
    getStatusText,
    getStatusColor,
    formatDate,
    formatTtlDate,
    getProgressPercentage,
}) => {
    const navigate = useNavigate();
    // Prevent row click when clicking the delete button
    const handleRowClick = (e: React.MouseEvent) => {
        // If the click is inside the delete button, do nothing
        if ((e.target as HTMLElement).closest('button')) return;
        navigate(`/admin/download-jobs/${job.id}`);
    };
    return (
        <TableRow
            key={job.id}
            hover
            sx={{ cursor: 'pointer' }}
            onClick={handleRowClick}
        >
            <TableCell>
                <Typography variant="body2" fontFamily="monospace">
                    {job.id}
                </Typography>
            </TableCell>
            <TableCell>
                <Chip
                    label={getStatusText(job.state)}
                    color={getStatusColor(job.state) as any}
                    size="small"
                />
            </TableCell>
            <TableCell>{job.imagesToDownloadCount}</TableCell>
            <TableCell>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ width: '100px' }}>
                        <LinearProgress
                            variant="determinate"
                            value={getProgressPercentage(job)}
                        />
                    </Box>
                    <Typography variant="body2">
                        {job.imagesProcessedCount}/{job.imagesToDownloadCount} ({getProgressPercentage(job)}%)
                    </Typography>
                </Box>
            </TableCell>
            <TableCell>
                <Typography variant="body2">{formatDate(job.createdTime)}</Typography>
            </TableCell>
            <TableCell>
                <Typography variant="body2">{formatDate(job.latestModifiedTime)}</Typography>
            </TableCell>
            <TableCell>
                <Typography variant="body2">{formatDate(job.completedTime)}</Typography>
            </TableCell>
            <TableCell>
                <Typography variant="body2">{formatTtlDate(job.ttl)}</Typography>
            </TableCell>
            <TableCell>
                {job.failureReason && (
                    <Typography variant="body2" color="error">
                        {job.failureReason}
                    </Typography>
                )}
            </TableCell>
            <TableCell>
                <Tooltip title="Ta bort jobb">
                    <span>
                        <IconButton
                            aria-label="Ta bort jobb"
                            color="error"
                            size="small"
                            onClick={(e) => { e.stopPropagation(); onDelete(job.id); }}
                            disabled={isDeleting}
                        >
                            {isDeleting ? <CircularProgress size={18} /> : <DeleteIcon />}
                        </IconButton>
                    </span>
                </Tooltip>
            </TableCell>
        </TableRow>
    );
};

export default DownloadJobRow;
